import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { SatpenTableItemStats } from '@/apis/types'

import { JenjangStats } from '../JenjangStats/JenjangStats'
import { JenjangStatsLoader } from '../JenjangStats/JenjangStatsLoader'
import { ProvinceImage } from '../ProvinceLogoCard/ProvinceImage'

interface AreaStatsProps {
  title: string
  image: string
  stats: SatpenTableItemStats[]
  isPending?: boolean
  imageClass?: string
  withImage?: boolean
  level?: 'district' | 'country'
}

export const AreaSummaryStats = ({
  title,
  image,
  stats,
  isPending = false,
  imageClass,
  withImage = false,
  level = 'district',
}: AreaStatsProps) => {
  return (
    <div
      className={clsx('rounded-lg bg-blue-90 p-4')}
      data-testid="area-summary-stats"
    >
      <div className="flex items-center gap-4">
        {withImage && (
          <ProvinceImage
            image={image}
            alt={title}
            level={level}
            className={imageClass}
          />
        )}

        <Text color="inverse" variant="action">
          {title}
        </Text>
      </div>
      {isPending ? <JenjangStatsLoader /> : <JenjangStats items={stats} />}
    </div>
  )
}
